import { getAgentClientLabel } from './agentIdentity';
import { AI_AGENT_TAG } from './aiPrincipal';
export var QuerySurface;
(function (QuerySurface) {
    QuerySurface["APP"] = "app";
    QuerySurface["SLACK"] = "slack";
    QuerySurface["MCP"] = "mcp";
    QuerySurface["CLI"] = "cli";
    QuerySurface["API"] = "api";
})(QuerySurface || (QuerySurface = {}));
export var QueryExecutionContext;
(function (QueryExecutionContext) {
    QueryExecutionContext["DASHBOARD"] = "dashboardView";
    QueryExecutionContext["AUTOREFRESHED_DASHBOARD"] = "autorefreshedDashboard";
    QueryExecutionContext["EXPLORE"] = "exploreView";
    QueryExecutionContext["FILTER_AUTOCOMPLETE"] = "filterAutocomplete";
    QueryExecutionContext["CHART"] = "chartView";
    QueryExecutionContext["CHART_HISTORY"] = "chartHistory";
    QueryExecutionContext["SQL_CHART"] = "sqlChartView";
    QueryExecutionContext["SQL_RUNNER"] = "sqlRunner";
    QueryExecutionContext["VIEW_UNDERLYING_DATA"] = "viewUnderlyingData";
    QueryExecutionContext["ALERT"] = "alert";
    QueryExecutionContext["SCHEDULED_DELIVERY"] = "scheduledDelivery";
    QueryExecutionContext["CSV"] = "csvDownload";
    QueryExecutionContext["GSHEETS"] = "gsheets";
    QueryExecutionContext["GSHEETS_ADDON"] = "gsheetsAddon";
    QueryExecutionContext["SCHEDULED_GSHEETS_CHART"] = "scheduledGsheetsChart";
    QueryExecutionContext["SCHEDULED_GSHEETS_DASHBOARD"] = "scheduledGsheetsDashboard";
    QueryExecutionContext["SCHEDULED_GSHEETS_SQL_CHART"] = "scheduledGsheetsSqlChart";
    QueryExecutionContext["SCHEDULED_CHART"] = "scheduledChart";
    QueryExecutionContext["SCHEDULED_DASHBOARD"] = "scheduledDashboard";
    QueryExecutionContext["CALCULATE_TOTAL"] = "calculateTotal";
    QueryExecutionContext["CALCULATE_SUBTOTAL"] = "calculateSubtotal";
    QueryExecutionContext["EMBED"] = "embed";
    QueryExecutionContext["AI"] = "ai";
    QueryExecutionContext["MCP_RUN_METRIC_QUERY"] = "mcp.run_metric_query";
    QueryExecutionContext["MCP_RUN_SQL"] = "mcp.run_sql";
    QueryExecutionContext["MCP_SEARCH_FIELD_VALUES"] = "mcp.search_field_values";
    QueryExecutionContext["API"] = "api";
    QueryExecutionContext["CLI"] = "cli";
    QueryExecutionContext["METRICS_EXPLORER"] = "metricsExplorer";
    QueryExecutionContext["PRE_AGGREGATE_MATERIALIZATION"] = "preAggregateMaterialization";
    QueryExecutionContext["COMPOSE_SQL_RUNNER"] = "composeSqlRunner";
    QueryExecutionContext["PYTHON_RUNNER"] = "pythonRunner";
    QueryExecutionContext["MULTI_SOURCE_QUERY"] = "multiSourceQuery";
    QueryExecutionContext["DATA_APP_SAMPLE"] = "dataAppSample";
    QueryExecutionContext["DESKTOP"] = "desktop";
})(QueryExecutionContext || (QueryExecutionContext = {}));
export const isAiAccessQueryContext = (context) => context === QueryExecutionContext.DATA_APP_SAMPLE ||
    context === QueryExecutionContext.AI ||
    context === QueryExecutionContext.MCP_RUN_METRIC_QUERY ||
    context === QueryExecutionContext.MCP_RUN_SQL ||
    context === QueryExecutionContext.MCP_SEARCH_FIELD_VALUES;
export const withAgentMarkerTag = (tags, agentIdentity = null) => {
    const marked = isAiAccessQueryContext(tags.query_context)
        ? { ...tags, [AI_AGENT_TAG]: 'true' }
        : tags;
    return agentIdentity
        ? {
            ...marked,
            agent_surface: agentIdentity.act.surface,
            agent_client: getAgentClientLabel(agentIdentity.act.client_id),
            ...(agentIdentity.act.agent_uuid
                ? { agent_uuid: agentIdentity.act.agent_uuid }
                : {}),
        }
        : marked;
};
//# sourceMappingURL=analytics.js.map